import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.88,0H4.4A1.54,1.54,0,0,0,3.12,1.57V19.05a1.73,1.73,0,0,0,1.11,1.62l8,3.2a1.79,1.79,0,0,0,1.64-.17,1.75,1.75,0,0,0,.76-1.45v-17a1.75,1.75,0,0,0-1.1-1.63L10.66,2.48a.25.25,0,0,1-.15-.28.26.26,0,0,1,.25-.2h7.86a.26.26,0,0,1,.26.25V18.72a.26.26,0,0,1-.26.25H16.88a1,1,0,1,0,0,2h2a2,2,0,0,0,2-2V2A2,2,0,0,0,18.88,0Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }